import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

export const getMonthName = (monthNumber) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return months[monthNumber - 1];
};

export const dateDifference = (dateFrom, dateTo) => {
  const from = dayjs(dateFrom, "YYYY-MM-DD");
  const to = dayjs(dateTo, "YYYY-MM-DD");

  return to.diff(from, "days");
};

export const formatDuration = (seconds) => {
  const dur = dayjs.duration(seconds, "seconds");

  const days = dur.days();
  const hours = dur.hours();
  const minutes = dur.minutes();

  let result = "";
  if (days > 0) result += `${days} days `;
  if (hours > 0) result += `${hours} h `;
  if (minutes > 0) result += `${minutes} min`;

  return result.trim();
};

export const today = dayjs().format("YYYY-MM-DD");

export const tomorrow = dayjs().add(1, "day").format("YYYY-MM-DD");

export const formatShortDate = (date) => {
  if (!date) return null;
  return dayjs(date).format("MM/DD");
};

export const formatTimestamp = (timestamp) => {
  if (!timestamp) return null;
  const date = dayjs(timestamp);
  return date.isSame(dayjs(), "day") ? date.format("h:mm A") : date.format("MMM D, h:mm A");
};

export const formatAge = (timestamp) => {
  if (!timestamp) return "-";
  const diffSeconds = dayjs().diff(dayjs(timestamp), "seconds");
  const diffMinutes = dayjs().diff(dayjs(timestamp), "minutes");
  const diffHours = dayjs().diff(dayjs(timestamp), "hours");
  const diffDays = dayjs().diff(dayjs(timestamp), "days");

  if (diffMinutes === 0) return `${diffSeconds} sec`;
  if (diffMinutes < 60) return `${diffMinutes} min`;
  if (diffHours < 24) return `${diffHours} hr`;
  return `${diffDays} day${diffDays > 1 ? "s" : ""}`;
};
